import React from 'react';
import { compose } from 'redux';
import CommonContainer from '../../common/CommonContainer';
import withStyles from '@material-ui/core/styles/withStyles';
import RenderBreakpoint from '../../common/breakpoints/RenderBreakpoint';
import MobileTable from './MobileTable';
import Grow from '@material-ui/core/Grow';
import RegularTable from './RegularTable';
import CircularProgress from '@material-ui/core/CircularProgress';
import NoDataAvailableWithIcon from '../charts/NoDataAvailableWithIcon';
import { FormattedMessage } from 'react-intl';

const styles = (theme => ({
  tableHeader: {
    alignSelf: 'center',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  tableFooter: {
    margin: `${theme.spacing(2)}px ${theme.spacing(2)}px 0px ${theme.spacing(2)}px`,
    textAlign: 'left',
    width: '90%',
  },
  mobileTitle: {
    margin: theme.spacing(2),
    textAlign: 'center',
  },
  noDataFound: {
    marginTop: theme.spacing(4),
    fontSize: 16,
  },
}));

const CommonTable = ({ classes, title, data, tableConfig, footerContent }) => {
  
  if (!data) {
    return (<CommonContainer vAlign="center">
        <CircularProgress />
      </CommonContainer>
    );
  }
  
  if (data.length === 0) {
    return (
      <CommonContainer className={classes.noDataFound}>
        <NoDataAvailableWithIcon
          customText={<FormattedMessage id="report.title.NoDataFound" defaultMessage="No data found" />}
        />
      </CommonContainer>
    );
  }
  
  const renderTitle = title && (
    <h1 className={classes.tableHeader}>
      {title}
    </h1>
  );
  
  const renderFooter = footerContent && <div className={classes.tableFooter}>
    {footerContent}
  </div>;
  
  return (
    <>
      <RenderBreakpoint desktop>
        <Grow timeout={800} in={true}>
          <CommonContainer
            hAlign="center"
          >
            {renderTitle}
            
            <RegularTable
              data={data}
              tableConfig={tableConfig}
            />
            
            {renderFooter}
          
          </CommonContainer>
        </Grow>
      </RenderBreakpoint>
      
      <RenderBreakpoint mobile>
        
        <div className={classes.mobileTitle}>
          <h1>
            {title}
          </h1>
        </div>
        
        <MobileTable
          data={data}
          columns={tableConfig}
        />
        
        {renderFooter}
      
      </RenderBreakpoint>
    </>
  );
};

const decorate = compose(
  withStyles(styles),
);

export default decorate(CommonTable);